import ExcelJS from "exceljs";
import axios from "axios";
import { saveAs } from "file-saver"; // For saving the file
import { IndiaState } from "../../../shared/enums";
import { PRODUCT_TYPES } from "../../../shared/enums/productTypeList";

// Function to download Excel
export const downloadExcelForInputLocations = async (
  campaignName,
  productTypes,
  existingData = null,
  regions = [],
  organizationId,
) => {
  // Create a new workbook and worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Store Locations");

  // Define headers
  worksheet.columns = [
    { header: "Store Name", width: 20 }, //A
    { header: "Store Owner Name", width: 20 }, //B
    { header: "Store Owner Contact Number", width: 25 }, //C
    { header: "Address", width: 25 }, //D
    { header: "City", width: 20 }, //E
    { header: "State", width: 20 }, //F
    { header: "PinCode", width: 15 }, //G
    { header: "Zone", width: 15 }, //H
    { header: "Landmark", width: 35 }, //I
    // { header: "Product Type", width: 35 }, // J
    // { header: "Width", width: 15 }, //K
    // { header: "Height", width: 15 }, //L
    // { header: "Thickness", width: 15 },//M
    { header: "Location Link", width: 35 }, //N
    { header: "Driver Name", width: 20 }, //O
    { header: "Driver Contact Number", width: 25 }, //O
    { header: "Driver Vehicle Number", width: 25 }, //P
    { header: "SO Name", width: 25 }, //Q
    { header: "SO Contact Number", width: 25 }, //R
  ];

  // ✅ Create hidden sheet for Product Types
  // const hiddenSheet = workbook.addWorksheet("ProductTypes");
  // hiddenSheet.state = "veryHidden";

  // Fill product types in column A of hidden sheet
  // add new product types
  // if (productTypes.length > 0) {
  //   productTypes.forEach((type, idx) => {
  //     hiddenSheet.getCell(`A${idx + 1}`).value = type;
  //   });
  // } else {
  //   PRODUCT_TYPES.forEach((type, idx) => {
  //     hiddenSheet.getCell(`A${idx + 1}`).value = type;
  //   });
  // }

  // const productTypesCount =
  //   productTypes.length > 0 ? productTypes.length : PRODUCT_TYPES.length;

  // create hidden sheet for zones
  if (!regions || regions.length == 0) {
    const serverURL = process.env.REACT_APP_URL;
    const response = await axios.get(
      `${serverURL}/organization/view/${organizationId._id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );

    if (!response.data.success) return;

    regions = response?.data?.regions || [];
  }
  const hiddenZones = workbook.addWorksheet("Zones");
  // hiddenZones.state = "veryHidden";
  // fill zones in hidden sheet

  // Flatten regions into [state, zoneName] pairs. First region wins on duplicates.
  const stateZonePairs = [];
  const seenStates = new Set();
  (regions || [])
    .filter((r) => r?.isActive !== false && r?.isDeleted !== true)
    .forEach((region) => {
      (region.states || []).forEach((state) => {
        const key = state.trim().toLowerCase();
        if (seenStates.has(key)) return;
        seenStates.add(key);
        stateZonePairs.push([state.trim(), region.regionName]);
      });
    });

  stateZonePairs.forEach(([state, zone], idx) => {
    hiddenZones.getCell(`A${idx + 1}`).value = state;
    hiddenZones.getCell(`B${idx + 1}`).value = zone;
  });

  const zoneRowCount = stateZonePairs.length;
  // --- Add existing data rows if provided ---
  if (existingData && existingData.rows && existingData.rows.length > 0) {
    existingData.rows.forEach((row) => {
      const rowObj = [];
      existingData.headers.forEach((header, idx) => {
        const colIndex = worksheet.columns.findIndex(
          (col) => col.header === header,
        );
        if (colIndex !== -1) {
          rowObj[colIndex] = row[idx];
        }
      });
      worksheet.addRow(rowObj);
    });
  } else {
    worksheet.addRow({});
  }

  const mandatoryColumns = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    // "I",
    // "J",
    // "K",
    // "L",
  ];

  mandatoryColumns.forEach((column, index) => {
    const cell = `${column}2`; // Assuming the first row is headers
    worksheet.getCell(cell).dataValidation = {
      type: "custom",
      allowBlank: false,
      showErrorMessage: true,
      errorTitle: "Mandatory Field",
      error: `Please fill in the ${worksheet.columns[index].header} field.`,
      formulae: [`LEN(${cell})>0`],
    };
  });

  const existingRowCount = existingData?.rows?.length || 0;
  const lastDataRow = existingRowCount + 1; // row 1 is the header

  // Add dropdown & validations
  for (let i = 2; i <= 4000; i++) {
    worksheet.getCell(`G${i}`).dataValidation = {
      type: "whole",
      operator: "between",
      showErrorMessage: true,
      errorTitle: "Invalid Pincode",
      error: "Please enter a valid 6-digit Pincode.",
      allowBlank: false,
      formulae: [100000, 999999],
    };

    worksheet.getCell(`C${i}`).dataValidation = {
      type: "whole",
      operator: "between",
      showErrorMessage: true,
      errorTitle: "Invalid Phone number",
      error: "Please enter a valid Phone Number.",
      allowBlank: false,
      formulae: [1000000000, 9999999999],
    };

    if (zoneRowCount > 0) {
      // State dropdown so spellings match the lookup table
      worksheet.getCell(`F${i}`).dataValidation = {
        type: "list",
        allowBlank: false,
        formulae: [`Zones!$A$1:$A$${zoneRowCount}`],
        showErrorMessage: true,
        errorStyle: "warning",
        errorTitle: "Unknown State",
        error:
          "Select a state from the list so the Zone can be filled automatically.",
      };

      // Zone auto-fills from State
      worksheet.getCell(`H${i}`).value = {
        formula: `IF(TRIM(F${i})="","",IFERROR(VLOOKUP(TRIM(F${i}),Zones!$A$1:$B$${zoneRowCount},2,FALSE),""))`,
        result: "",
      };
    }
  }
  // Generate Excel file buffer
  const buffer = await workbook.xlsx.writeBuffer();

  // Create a Blob from the buffer
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Save the Excel file
  saveAs(blob, `${campaignName}_storeLocations_template.xlsx`);
};
